import Navbar from './components/Navbar';
import Hero from './components/Hero';
import NewsFeed from './components/NewsFeed';
import Timeline from './components/Timeline';
import Evidence from './components/Evidence';
import Reviews from './components/Reviews';
import ClueIndex from './components/ClueIndex';
import Workflow from './components/Workflow';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="bg-background-50">
      <Navbar />
      <Hero />
      <NewsFeed />
      <Timeline />
      <Evidence />
      <Reviews />
      <ClueIndex />
      <Workflow />
      <Footer />
    </main>
  );
}